import { render, staticRenderFns } from "./sentenceGroupCheckbox.vue?vue&type=template&id=6eb36cf2&"
import script from "./sentenceGroupCheckbox.vue?vue&type=script&lang=js&"
export * from "./sentenceGroupCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./sentenceGroupCheckbox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports